<template>
<div>
<div v-if="!manageProfile">
        <b-autocomplete
          class="AutoWrapper d-none"
          v-model="PatientsProfile"
          >
        </b-autocomplete>
        <el-row>
        <v-layout row wrap class="clearfix">
        <v-flex md6 >
          <v-flex md-4 class="flex-center">
          <avatar
            class="mb-3 flex-center flex-direction-column"
            v-if='profile.image === null'
            :username="selectedPatients.name"
            :size="80">
          </avatar>
          <div v-else class="imgWidth mb-3">
          <img :src=" profile.image "/>
          </div>
          </v-flex>
          <div class="mb-3 col flex-center flex-direction-column">
            <div class="mb-3">{{ selectedPatients.name}}</div>
          <v-layout class="p-0">

          <v-flex :class="selectedPatients.age && selectedPatients.gender?'mr-4':''" >{{ selectedPatients.age }} <span v-if='selectedPatients.age && selectedPatients.gender ' >/</span> {{ selectedPatients.gender }}</v-flex>
          <v-flex >{{ selectedPatients.number }} </v-flex>

          </v-layout>
          <v-layout>

          <v-flex >  <el-button  @click.native="manageProfile = !manageProfile" type="primary">Manage Profile</el-button> </v-flex>
        <a :href="profile.prescription" target="_blank">
          <v-flex class="ml-3">  <el-button :disabled="profile.prescription === null" type="primary" plain> Prescription </el-button> </v-flex>
        </a>
          </v-layout>
        </div>
        <div >

        </div>
        </v-flex>
        <v-flex md6>
          <div class="summary" v-for="(summary,index) in profile.summary">
           <div v-if="summary.value.length > 0">
          <h6 class="summaryHeading"> {{summary.title}}  </h6>
          <div v-for="(value,valueindex) in summary.value">
          <p class="summarySubHeading"> {{ value.title}} </p>
          <p class="summaryDesc"> {{value.value }}</p>
          </div>
          </div>
          </div>
        </v-flex>
        </v-layout>
        </el-row>
  <!-- <el-input v-model="PatientsProfile"></el-input> -->
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>


  </v-card-actions>
</div>
<div v-else>
  <div md12 style="    margin-right: 30px;
    text-align: right;">
    <el-button type="primary" plain  @click.native="manageProfile = !manageProfile">Back</el-button>
  </div>
  <NewRegistrationEl :FlipCard='this.FlipCard' :selectedPatient='this.selectedPatients.person_id+""'/>
</div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import $ from 'jquery';
import { api, jQuery401Callback } from '../api.js';
import { store } from '../store.js';
import { axios, get, post } from 'axios';
import Avatar from 'vue-avatar';
import NewRegistrationEl from './NewRegistrationEl';

export default {
  name: 'ViewProfile',
  mounted() {
    // this.patient_name_search()
  },
  props: {
    selectedPatients: {
      default: () => ({}),
      type: Object
    },
    manageProfile: {
      type: Boolean
    }
  },
  created() {
    // this.searchByVal("a");
  },
  // components:{
  //   Quasar
  // },
  components: {
    // Autocomplete
    avatar: Avatar,
    NewRegistrationEl
  },
  data() {
    return {
      profile: {},
      manageProfile: false
    };
  },
  watch: {},
  beforeDestroy: function() {
    console.log('Before');
  },
  destroyed: function() {
    console.log('Destroyed');
  },
  computed: {
    PatientsProfile: {
      get() {
        // console.log('Getter');
        console.log(this.manageProfile);
        this.manageProfile = true;

        if (this.selectedPatients.length !== 0) {
          this.FetchPatients(this.selectedPatients.person_id);
          return this.selectedPatients;
        }
        // this.searchByVal('bal');
        // console.log(this.selectedPatients);
        // if (this.selectedPatients.person_id !== '') {
        //   this.passSelected(this.selectedPatients);
        // }
        // return this.selectedPatients;
      },
      set(newValue) {
        console.log('setter');
        // this.passSelected(newValue);
      }
    }
  },

  methods: {
    FlipCard() {
      //this.FetchPatients(this.selectedPatients.person_id);

      this.manageProfile = !this.manageProfile;
    },
    FetchPatients(val) {
      this.manageProfile = false;
      console.log('Fetch');
      let token = localStorage.getItem('token', this.token);
      $.ajax({
        // http://dev.slashdr.com/v2/simple_summary?person_id=991
        url: api + '/v2/simple_summary?person_id=' + val,
        type: 'GET',
        headers: {
          token: token
        },
        error: jQuery401Callback

      }).then(response => {
        // console.log(response.length);
        if (response !== null) {
          this.profile = response;
        }
      });
    }
  }
};
</script>
<style scoped>
.imgWidth {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.imgWidth img {
  border-radius: 50%;
  width: 100%;
  height: 100%;
}
.layout {
  padding: 1rem;
}
.card__actions {
  padding: 1rem;
}
.el-date-editor {
  width: 100%;
  padding-right: 1rem;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mb-3 {
  margin-bottom: 2rem;
}
.p-0 {
  padding: 0;
}
.flex-direction-column {
  flex-direction: column;
}
.dialog.dialog--persistent {
  overflow: scroll;
}
.summaryHeading {
  padding: 7px;
  font-size: 18px;
  background: #eee;
  font-weight: 600;
}
.summarySubHeading {
  font-weight: 800;
  padding: 7px;
}
.summaryDesc {
  padding: 7px;
}
.summary {
  margin-bottom: 10px;
}
</style>
<style>
.d-none {
  display: none;
}
.dialog--scrollable {
  overflow: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/components/viewProfile.vue